class r {
  constructor() {
    this.decimalSeparator = ",";
  }
  zipcode(a) {
    return !!a.match(/^((0[1-9])|([12][0-9])|30|31|32)([0-8][0-9])([0-9]{2})$/);
  }
}
export {
  r as default
};
